export enum COTabsProps {
  type = 'line'
}